<template>
    <section style="
      padding-left: 25px;
      margin-left: 20px;
      padding-right: 10px;
      margin-right: 10px;
    ">
        <!-- Bouton d'ajout -->
        <v-row>
            <v-col cols="12" sm="12" md="6">
                <v-row>
                    <v-col cols="12" sm="12" md="5">
                        <v-btn @click="addCard = !addCard" class="info ml-6 mr-2 mt-4">
                            <v-icon left> {{ icons.mdiDatabasePlusOutline }} </v-icon>
                            {{ addCard ? "Fermer le formulaire" : "Ajouter un Coming Soon" }}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

        <!-- Formulaire d'Ajout (Affiché si addCard = true) -->
        <v-row v-if="addCard">
            <v-col cols="12">
                <v-card class="mb-6 ml-6 mr-2 mt-4 pa-4 elevation-2">
                    <v-card-title class="font-weight-bold">Ajouter un nouveau Coming Soon</v-card-title>
                    <v-form ref="addForm" v-model="isAddValid" lazy-validation>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" sm="12" md="4">
                                    <v-text-field v-model="newComingSoon.title" label="Titre (FR) *"
                                        placeholder="Ex: Nouvelle fonctionnalité" outlined dense :rules="rules.title"
                                        required></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="4">
                                    <v-text-field v-model="newComingSoon.titleEn" label="Titre (EN) *"
                                        placeholder="Ex: New Feature" outlined dense :rules="rules.titleEn"
                                        required></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="4">
                                    <v-select v-model="newComingSoon.month" :items="monthsList" label="Mois prévu *"
                                        outlined dense :rules="rules.month" required></v-select>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <v-textarea v-model="newComingSoon.description" label="Description (FR)"
                                        placeholder="Description détaillée en français" outlined dense rows="3"
                                        auto-grow></v-textarea>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <v-textarea v-model="newComingSoon.descriptionEn" label="Description (EN)"
                                        placeholder="Detailed description in English" outlined dense rows="3"
                                        auto-grow></v-textarea>
                                </v-col>
                            </v-row>
                        </v-card-text>

                        <v-card-actions class="px-4">
                            <v-spacer></v-spacer>
                            <v-btn text color="error" @click="resetAddForm" :disabled="loadingAdd">
                                Annuler
                            </v-btn>
                            <v-btn color="info" @click="createComingSoon" :loading="loadingAdd"
                                :disabled="!isAddValid">
                                Enregistrer
                            </v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-col>
        </v-row>

        <!-- Tableau des Coming Soon -->
        <v-card class="mb-6 ml-6 mt-6 mr-2">
            <v-card-title>
                Liste des Coming Soon
                <v-spacer></v-spacer>
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Recherche" single-line hide-details
                    clearable dense outlined class="shrink" style="max-width: 300px;"></v-text-field>
            </v-card-title>

            <v-data-table :headers="headers" :items="comingSoonItems" :search="search" :loading="isLoadingTables"
                loading-text="Chargement des données..." class="elevation-1" item-key="id" :footer-props="{
                    'items-per-page-options': [5, 10, 15, 30],
                }">
                <template v-slot:[`item.month`]="{ item }">
                    <v-chip>
                        {{ formatMonth(item.month) }}
                    </v-chip>
                </template>

                <template v-slot:[`item.modifier`]="{ item }">
                    <v-icon @click="editComingSoon(item)">
                        {{ icons.mdiPencil }}
                    </v-icon>
                </template>

                <template v-slot:[`item.supprimer`]="{ item }">
                    <v-icon @click="deleteComingSoon(item)" >
                        {{ icons.mdiDeleteOutline }}
                    </v-icon>
                </template>
            </v-data-table>
        </v-card>

        <!-- Modal de Modification -->
        <v-dialog v-model="dialogEdit" max-width="700px" persistent>
            <v-card>
                <v-card-title class="headline font-weight-bold">
                    Modifier le Coming Soon #{{ comingSoonToEdit.id }}
                </v-card-title>

                <v-form ref="editForm" v-model="isEditValid" lazy-validation>
                    <v-card-text class="pt-4">
                        <v-row>
                            <v-col cols="12" sm="12" md="4">
                                <v-text-field v-model="comingSoonToEdit.title" label="Titre (FR) *" outlined dense
                                    :rules="rules.title" required></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="12" md="4">
                                <v-text-field v-model="comingSoonToEdit.titleEn" label="Titre (EN) *" outlined dense
                                    :rules="rules.titleEn" required></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="12" md="4">
                                <v-select v-model="comingSoonToEdit.month" :items="monthsList" label="Mois prévu *"
                                    outlined dense :rules="rules.month" required></v-select>
                            </v-col>
                            <v-col cols="12" sm="12" md="6">
                                <v-textarea v-model="comingSoonToEdit.description" label="Description (FR)" outlined
                                    dense rows="3" auto-grow></v-textarea>
                            </v-col>
                            <v-col cols="12" sm="12" md="6">
                                <v-textarea v-model="comingSoonToEdit.descriptionEn" label="Description (EN)"
                                    outlined dense rows="3" auto-grow></v-textarea>
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-card-actions class="px-4 pb-4">
                        <v-spacer></v-spacer>
                        <v-btn text color="error" @click="dialogEdit = false" :disabled="loadingEdit">
                            Annuler
                        </v-btn>
                        <v-btn color="info" @click="updateComingSoon" :loading="loadingEdit"
                            :disabled="!isEditValid">
                            Sauvegarder
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>

        <!-- Modal de Confirmation de Suppression -->
        <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
                <v-card-title class="text-h6">
                    Confirmation de suppression
                </v-card-title>
                <v-card-text class="pt-2">
                    Êtes-vous sûr de vouloir supprimer le Coming Soon :
                    <strong>"{{ comingSoonToDelete.title }}"</strong> ?
                </v-card-text>
                <v-card-actions class="px-4 pb-4">
                    <v-spacer></v-spacer>
                    <v-btn text color="grey darken-1" @click="dialogDelete = false" :disabled="loadingDelete">
                        Annuler
                    </v-btn>
                    <v-btn color="error" @click="confirmDeleteComingSoon" :loading="loadingDelete">
                        Supprimer
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Notification Snackbar -->
        <v-snackbar v-model="snackbar.visible" :color="snackbar.color" :timeout="snackbar.timeout"
            :top="snackbar.position === 'top'">
            {{ snackbar.text }}
            <template v-slot:action="{ attrs }">
                <v-btn text v-bind="attrs" @click="snackbar.visible = false">
                    Fermer
                </v-btn>
            </template>
        </v-snackbar>
    </section>
</template>

<script>
import {
    mdiDatabasePlusOutline,
    mdiMagnify,
    mdiPencil,
    mdiDeleteOutline,
} from '@mdi/js';
import Constant from "@/utils/constants";
import axios from 'axios';
import { FetchAllComingSoon } from '@/views/qorani/services/services';

export default {
    data() {
        return {
            addCard: false,
            isAddValid: true,
            loadingAdd: false,
            newComingSoon: {
                title: '',
                titleEn: '',
                description: '',
                descriptionEn: '',
                month: null,
            },

            // Tableau
            search: '',
            isLoadingTables: false,
            comingSoonItems: [],
            headers: [
                { text: "ID", value: "id"},
                { text: "Titre (FR)", value: "title"},
                { text: "Titre (EN)", value: "titleEn"},
                { text: "Description (FR)", value: "description"},
                { text: "Description (EN)", value: "descriptionEn"},
                { text: "Mois", value: "month"},
                { text: "Modifier", value: "modifier"},
                { text: "Supprimer", value: "supprimer"},
            ],
            monthsList: [
                { text: 'Janvier (1)', value: 0 },
                { text: 'Février (2)', value: 1 },
                { text: 'Mars (3)', value: 2 },
                { text: 'Avril (4)', value: 3 },
                { text: 'Mai (5)', value: 4 },
                { text: 'Juin (6)', value: 5 },
                { text: 'Juillet (7)', value: 6 },
                { text: 'Août (8)', value: 7 },
                { text: 'Septembre (9)', value: 8 },
                { text: 'Octobre (10)', value: 9 },
                { text: 'Novembre (11)', value: 10 },
                { text: 'Décembre (12)', value: 11 },
            ],
            dialogEdit: false,
            isEditValid: true,
            loadingEdit: false,
            comingSoonToEdit: {
                id: null,
                title: '',
                titleEn: '',
                description: '',
                descriptionEn: '',
                month: null,
            },

            dialogDelete: false,
            loadingDelete: false,
            comingSoonToDelete: {
                id: null,
                title: '',
            },

            rules: {
                title: [(v) => !!v || "Le titre (FR) est requis"],
                titleEn: [(v) => !!v || "Le titre (EN) est requis"],
                month: [(v) => (v !== null && v !== undefined && v !== '') || "Le mois est requis"],
            },

            snackbar: {
                visible: false,
                text: '',
                color: 'success',
                timeout: 3000,
                position: 'top',
            },

            // Icônes
            icons: {
                mdiDatabasePlusOutline,
                mdiMagnify,
                mdiPencil,
                mdiDeleteOutline,
            },
        };
    },
    methods: {
        formatMonth(month) {
            const found = this.monthsList.find((m) => m.value === Number(month));
            return found ? found.text : (month || '-');
        },

        async fetchAllComingSoon() {
            this.isLoadingTables = true;
            try {
                this.comingSoonItems = await FetchAllComingSoon();
            } catch (error) {
                console.error("Erreur lors de la récupération des Coming Soon:", error);
                this.showSnackbar("Erreur lors du chargement des Coming Soon", "error");
            } finally {
                this.isLoadingTables = false;
            }
        },

        async createComingSoon() {
            if (!this.$refs.addForm.validate()) return;

            this.loadingAdd = true;
            try {
                const payload = {
                    title: this.newComingSoon.title,
                    titleEn: this.newComingSoon.titleEn,
                    description: this.newComingSoon.description,
                    descriptionEn: this.newComingSoon.descriptionEn,
                    month: Number(this.newComingSoon.month),
                };
                await axios.post(`${Constant.QORANI}comingSoon/add`, payload);

                this.showSnackbar("Coming Soon ajouté avec succès !", "success");
                this.resetAddForm();
                this.addCard = false;
                await this.fetchAllComingSoon();
            } catch (error) {
                console.error("Erreur lors de l'ajout du Coming Soon:", error);
                this.showSnackbar(
                    error?.response?.data?.message || "Erreur lors de l'ajout du Coming Soon",
                    "error"
                );
            } finally {
                this.loadingAdd = false;
            }
        },

        resetAddForm() {
            this.newComingSoon = {
                title: '',
                titleEn: '',
                description: '',
                descriptionEn: '',
                month: null,
            };
            if (this.$refs.addForm) {
                this.$refs.addForm.resetValidation();
            }
            this.addCard = false;
        },

        editComingSoon(item) {
            this.comingSoonToEdit = {
                id: item.id,
                title: item.title,
                titleEn: item.titleEn,
                description: item.description,
                descriptionEn: item.descriptionEn,
                month: item.month ? Number(item.month) : null,
            };
            this.dialogEdit = true;
            this.$nextTick(() => {
                if (this.$refs.editForm) {
                    this.$refs.editForm.resetValidation();
                }
            });
        },

        async updateComingSoon() {
            if (!this.$refs.editForm.validate()) return;

            this.loadingEdit = true;
            try {
                const payload = {
                    title: this.comingSoonToEdit.title,
                    titleEn: this.comingSoonToEdit.titleEn,
                    description: this.comingSoonToEdit.description,
                    descriptionEn: this.comingSoonToEdit.descriptionEn,
                    month: Number(this.comingSoonToEdit.month),
                };
                await axios.post(
                    `${Constant.QORANI}comingSoon/edit/${this.comingSoonToEdit.id}`,
                    payload
                );

                this.showSnackbar("Coming Soon modifié avec succès !", "success");
                this.dialogEdit = false;
                await this.fetchAllComingSoon();
            } catch (error) {
                console.error("Erreur lors de la modification du Coming Soon:", error);
                this.showSnackbar(
                    error?.response?.data?.message || "Erreur lors de la modification du Coming Soon",
                    "error"
                );
            } finally {
                this.loadingEdit = false;
            }
        },

        deleteComingSoon(item) {
            this.comingSoonToDelete = { ...item };
            this.dialogDelete = true;
        },

        async confirmDeleteComingSoon() {
            this.loadingDelete = true;
            try {
                await axios.get(
                    `${Constant.QORANI}comingSoon/delete/${this.comingSoonToDelete.id}`
                );

                this.showSnackbar("Coming Soon supprimé avec succès !", "success");
                this.dialogDelete = false;
                await this.fetchAllComingSoon();
            } catch (error) {
                console.error("Erreur lors de la suppression du Coming Soon:", error);
                this.showSnackbar(
                    error?.response?.data?.message || "Erreur lors de la suppression du Coming Soon",
                    "error"
                );
            } finally {
                this.loadingDelete = false;
            }
        },

        showSnackbar(text, color = 'success') {
            this.snackbar.text = text;
            this.snackbar.color = color;
            this.snackbar.visible = true;
        },
    },
    async created() {
        await this.fetchAllComingSoon();
    },
};
</script>

<style scoped></style>
